module.exports = __webpack_public_path__ + "static/media/phone_7.e9bc0f21.png";